import {DOOR_CONFIGURATOR_PATH} from '@/modules/door-content/sanity/constants';
import {WINDOW_CONFIGURATOR_PATH} from '@/modules/window-content/sanity/constants';
import type {SITE_SETTINGS_QUERYResult} from '@/schemas/types';
import {ARTICLES_PAGE_PATH} from '@/shared/constants';

import type {LinkableDocumentTypes} from './schema';

export const LINK_FRAGMENT = `//groq
	...,
	reference-> {
		title,
		_type,
		"slug": slug.current,
	}
`;

export type LinkFragment = Omit<
	NonNullable<NonNullable<NonNullable<SITE_SETTINGS_QUERYResult>['footerLinks']>[number]>,
	'_type' | '_key'
>;

export const internalLinkToHref = (documentType?: LinkableDocumentTypes, slug?: string) => {
	switch (documentType) {
		case 'frontpage':
			return '/';
		case 'page':
			return slug ? `/${slug}` : '#';
		case 'article':
			return slug ? `${ARTICLES_PAGE_PATH}/${slug}` : '#';
		case 'articleFrontpage':
			return ARTICLES_PAGE_PATH;
		case 'windowContent':
			return WINDOW_CONFIGURATOR_PATH;
		case 'doorContent':
			return DOOR_CONFIGURATOR_PATH;
		default:
			console.warn('Document type not a known linkable type:', documentType);
			return '#';
	}
};

export const linkFragmentToHref = (link: LinkFragment) => {
	if (link.type === 'internal') {
		return internalLinkToHref(link.reference?._type, link.reference?.slug ?? '');
	}

	if (link.type === 'external') {
		return link.href ?? '#';
	}

	return '#';
};
